/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

jQuery(document).ready(function() {
		const discountUpdate = (variant) => {
			if(!variant) return;
		
			const discountEl = document.querySelector("[data-discount]");
		
			if (discountEl) {
				discountEl.classList.remove("hidden");
		
				const discountValueEl = discountEl.querySelector("[data-discount-value]");
				const price = variant.price;
				const comparePrice = variant.compare_at_price;
		
				if (price && comparePrice) {
					if(price !== comparePrice) {
						discountValueEl.innerText = `${Math.round(((comparePrice - price) / comparePrice) * 100)}`;
					} else {
						if (!discountEl.classList.contains("hidden")) {
							discountEl.classList.add("hidden");
						}
					}
				}
			}
		}

		const variantMetafieldTextUpdate = (variant) => {
			const productJsonEl = document.querySelector("[data-product-json]")
			const variantLabelEl = document.querySelector("[data-variant-custom-text]");

			if (variantLabelEl && productJsonEl) {
				const productJson = JSON.parse(productJsonEl.innerHTML);
				if (productJson) {
					const metaFields = productJson.variants_metafields;

					if (metaFields) {
						const selectedMetaVariant = metaFields.find(item => item.id === variant.id);
						
						if (selectedMetaVariant) {
							const customMetaText = selectedMetaVariant.metafields[0]?.custom_variant_text;

							if (customMetaText) {
								variantLabelEl.innerText = customMetaText;
								variantLabelEl.classList.remove("hidden");
							} else {
								variantLabelEl.innerText = "";
								if (!variantLabelEl.classList.contains("hidden")) variantLabelEl.classList.add("hidden");
							}
						}
					}
				}

			}
		}

		const hideDescriptionPartOnClick = () => {
			document.addEventListener("click", (e) => {
				if (e.target.closest("[data-variant-button]")) {
					const button = e.target.closest("[data-variant-button]");
					const customDescrEl = document.querySelector("[data-product-custom-description]");
					
					if(!customDescrEl) return;

					if (button.hasAttribute("data-hide-description")) {
						if (!customDescrEl.classList.contains("hide-text-part")) customDescrEl.classList.add("hide-text-part");
					} else {
						customDescrEl.classList.remove("hide-text-part");
					}
				}
			})
		}

		document.addEventListener('variant:changed', function(event) {
		  var variant = event.detail.variant;
			discountUpdate(variant);
			variantMetafieldTextUpdate(variant);
		});

		hideDescriptionPartOnClick();

    setTimeout(function() {

    	var uniqueTextV = document.getElementsByClassName("v-stl-uniquetext");
			var shopTheLookHotspots = document.getElementsByClassName("ShopTheLook__Dot");

			shopTheLookHotspots[0]?.addEventListener("click", function() {
				uniqueTextV[0].classList.add('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[1]?.addEventListener("click", function() {
				uniqueTextV[1].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[2]?.addEventListener("click", function() {
				uniqueTextV[2].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[3]?.addEventListener("click", function() {
				uniqueTextV[3].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[4]?.addEventListener("click", function() {
				uniqueTextV[4].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[5]?.addEventListener("click", function() {
				uniqueTextV[5].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[6].classList.remove('is-active-v');
			});
			shopTheLookHotspots[6]?.addEventListener("click", function() {
				uniqueTextV[6].classList.add('is-active-v');
				uniqueTextV[0].classList.remove('is-active-v');
				uniqueTextV[1].classList.remove('is-active-v');
				uniqueTextV[2].classList.remove('is-active-v');
				uniqueTextV[3].classList.remove('is-active-v');
				uniqueTextV[4].classList.remove('is-active-v');
				uniqueTextV[5].classList.remove('is-active-v');
			});
		}, 5000);
});

if (!window.customElements.get('announce-timer')) {
    class AnnounceTimer extends HTMLElement {
        constructor() {
            super();
            this.interval = null;
            // Removed unused this.startKey
        }
    
        connectedCallback() {
            const hourEl = this.querySelector('[data-timer-hours]');
            const minuteEl = this.querySelector('[data-timer-minutes]');
            const secondEl = this.querySelector('[data-timer-seconds]');

            // --- 1. Calculate Target End Time (Next Midnight - Local Time) ---
            
            // a. Determine the timestamp for the start of the next day (00:00:00)
            let endTime = new Date();
            endTime.setDate(endTime.getDate() + 1); // Set to tomorrow
            endTime.setHours(0, 0, 0, 0);           // Set time to 00:00:00.000
            const endTimeMs = endTime.getTime();
            
            // Store the end time on the element instance to avoid recalculating unnecessarily
            this.endTimeMs = endTimeMs;
    
            this.interval = setInterval(() => {
                const now = Date.now();
                
                // 2. Calculate Time Remaining
                let timeLeftMs = this.endTimeMs - now;
                
                // If the time is up, reset the end time for the NEXT day
                if (timeLeftMs <= 0) {
                    // Update the target to the day after the one that just passed (maintaining the 24hr cycle)
                    this.endTimeMs = this.endTimeMs + (24 * 60 * 60 * 1000); 
                    timeLeftMs = this.endTimeMs - now; // Recalculate time left
                }
                
                // 3. Convert remaining milliseconds to H:M:S
                const totalSeconds = Math.floor(timeLeftMs / 1000); 

                const hours = Math.floor(totalSeconds / 3600);
                const minutes = Math.floor((totalSeconds % 3600) / 60);
                const seconds = totalSeconds % 60;
    
                // 4. Update the display elements
                hourEl.textContent = String(hours).padStart(2, '0');
                minuteEl.textContent = String(minutes).padStart(2, '0');
                secondEl.textContent = String(seconds).padStart(2, '0');
            }, 1000);
        }
    
        disconnectedCallback() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    }

    window.customElements.define('announce-timer', AnnounceTimer);
}
